import getConfig from '@/host/apiConfig.js';
// import globaljs from '@/utils';
import axios from './http.js';
  
// 获取数据GET
export const getDataaxios = (url, data) => {
    return new Promise((resolve, reject) => {
        let urlPath;
        url.includes('?') ? urlPath = url + "&t=" + Date.now() : urlPath = url + "?t=" + Date.now();
        axios({
            method: 'GET',
            url: urlPath,
            params: data
        })
            .then(function (res) {
                // 接口请求回调
                resolve(res);
            })
            .catch(function (error) {
                // 接口异常
                reject(error);
                // console.log("接口异常", error);
            })
    });
};
// 获取数据POST
export const postDataaxios = (url, data) => {
    return new Promise((resolve, reject) => {
        let urlPath;
        url.includes('?') ? urlPath = url + "&t=" + Date.now() : urlPath = url + "?t=" + Date.now();
        axios({
            method: 'POST',
            url: urlPath,
            data: data
        })
            .then(function (res) {
                // 接口请求回调
                resolve(res);
            })
            .catch(function (error) {
                // 接口异常
                reject(error);
                // console.log("接口异常", error);
            })
    });
};
/**
 * 工具请求方法请求方法
 * @param {String} apiKey 接口
 * @param {Object} data 请求参数
 * @param {String} urlParam url拼接方式
 * @param {String} baseUrl 接口关键字
 */
const axiosAjax = (apiKey, data, urlParam, baseUrl = 'api') => {
    if (!urlParam) {
        try {
            if (getConfig(apiKey)[1].toLowerCase() == 'post' || getConfig(apiKey)[1].toLowerCase() == 'put' || getConfig(apiKey)[1].toLowerCase() == 'delete') {
                return postDataaxios(baseUrl + getConfig(apiKey)[0], data)
            } else if (getConfig(apiKey)[1].toLowerCase() == 'get') {
                return getDataaxios(baseUrl + getConfig(apiKey)[0], data)
            } else {
                throw new Error('请在app.js中明确请求方式!');
            }
        } catch (e) {
            throw new Error('请在app.js中明确问题!');
        }
    } else {
        try {
            if (getConfig(apiKey)[1].toLowerCase() == 'post' || getConfig(apiKey)[1].toLowerCase() == 'put' || getConfig(apiKey)[1].toLowerCase() == 'delete') {
                return postDataaxios(baseUrl + getConfig(apiKey)[0] + urlParam, data)
            } else if (getConfig(apiKey)[1].toLowerCase() == 'get') {
                return getDataaxios(baseUrl + getConfig(apiKey)[0] + urlParam, data)
            } else {
                throw new Error('请在app.js中明确请求方式!');
            }
        } catch (e) {
            throw new Error('请在app.js中明确问题!');
        }
    }
};
export default axiosAjax;



// WEBPACK FOOTER //
// ./src/host/axiosAjax.js